/**
 * Check if call connect available on QT option
 */
const isCallConnectActionNotAvailable = function (option) {
    if (!option) {
        return;
    }
    // hasCallConnectAction is for current QT while hasNextCallConnectAction is for next mapped Question
    return (
        (option.hasCallConnectAction && !option.isCallConnectAvailable) ||
        (option.hasNextCallConnectAction && !option.isNextCallConnectAvailable)
    );
};
export default isCallConnectActionNotAvailable;
